
import GreetTitle from '../components/common/GreetTitle.vue'
import adTextEmpty from '../components/common/adTextEmpty.vue'
import SearchBar from '../components/common/SearchBar.vue'
import recomendComF from '../components/home/recomendComF.vue'
import TitBar from '../components/home/TitBar.vue'
import Carousel from '../components/home/Carousel.vue'
import CategoryEntries from '../components/home/CategoryEntries.vue'
import HomeAggregate from '../components/home/HomeAggregate.vue'
import apiConfig from '@/config/api.config'
import { PLACEHOLDER_DATA_URI } from '@/assets/placeholder'
import { weightedSample, buildFeatured, sampleBySeed, stockFirst } from '@/unit/recommend'
import { fetchPublicConfig, getPublicConfig, resolveShopShortName } from '@/utils/publicConfig'
import { resolveProductImageUrl } from '@/utils/image'
import floatingScrollBehavior from '@/mixins/floatingScrollBehavior'

export default {
  name: 'Home',
  // 货篮钮 PEEK 状态机与智能助手 FAB 共用（mixins/floatingScrollBehavior），滚动行为/动画全站一致
  mixins: [floatingScrollBehavior],
  floatBtnRef: 'cartFloatBtn',
  data () {
    return {
      greetScroll: false,
      showTierBadge: true, // "惠/靓/正"角标全局开关（public config 下发；默认显示）
      isDisplay: false,
      icpNumber: '',
      loading: true,
      loadingMore: false,
      noMore: false,
      page: 1,
      limit: 60, // 瀑布流候选池规模（/recommendations/feed?size=）
      BATCH_SIZE: 6,
      // _feedSeed/_shuffledPool/_poolIndex 是非响应式内部状态（实例属性，首次在 fetchProducts 赋值），
      // 故不进 data——放 data 会触发 Vue2 reserved-key 警告（_ 前缀被 Vue 当 internal）。
      // 拖拽相关状态
      isDraggingCart: false,
      hasMovedCart: false,
      dragStartXCart: 0,
      dragStartYCart: 0,
      btnXCart: 0,
      btnYCart: 0,
      greet: {
        time: ''
      },
      addr: '',
      titmsg: ['精选推荐', '更多好货'],
      featuredProducts: [],
      featuredPool: [], // 精选商品完整池（强推保序 + 候选池加权抽样组装，同次进入稳定）
      products: [],
      productPool: [], // 瀑布流候选池（/recommendations/feed 一次取回，前端 weightedSample 抽样循环）
      defaultImage: PLACEHOLDER_DATA_URI
    }
  },
  computed: {
    // 问候语用户名：响应式跟随 store.user。
    // Home 被 keep-alive 缓存（router meta keepAlive:true），created 只执行一次，
    // 必须用 computed 才能在登录/登出/切换用户后自动刷新，否则问候语冻在首个用户。
    greetName () {
      const user = this.$store.getters.currentUser
      if (!user) return ''
      if (user.nickname) return user.nickname + '，'
      if (user.phone) return user.phone + '，'
      return '尊敬的用户，'
    },
    // 瀑布流双列：偶数索引入左列，奇数入右列
    // （移动端 CSS column-count 的列平衡不可控，改 Flex 双列手动均分）
    leftProducts () {
      return this.products.filter((_, i) => i % 2 === 0)
    },
    rightProducts () {
      return this.products.filter((_, i) => i % 2 === 1)
    },
    // 用户角色 - 使用 store getter
    userRole () {
      return this.$store.getters.userRole
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin
    },
    isCourier () {
      return this.$store.getters.isCourier
    },
    // 购物车角标/货篮浮钮单一真值 = store.cartCount（spec G-K）：删除/清空/下单在别页发生时，
    // keep-alive 缓存的 Home 靠响应式即时同步——本地副本曾导致"删完货篮回首页钮不消失（须刷新）"
    cartCount () {
      return this.$store.state.cartCount || 0
    },
    showCartFloat () {
      return this.cartCount > 0
    },
    // 是否处于商品管理模式
    isManageMode () {
      return localStorage.getItem('productManageMode') === 'true'
    }
  },
  components: {
    GreetTitle,
    SearchBar,
    TitBar,
    Carousel,
    CategoryEntries,
    HomeAggregate,
    adTextEmpty,
    recomendComF
  },
  created () {
    // 设置问候语时段（用户名改为 computed greetName 响应式跟随 store）
    const nowTime = new Date().getHours()
    this.greet.time = this.getGreetTime(nowTime)
    // 定位欢迎语两层（2026-09-11）：店铺名配置了用店铺名；未配置/未拉到 = 中性「欢迎光临」，
    // 不 fallback 系统品牌（路维智联是软件提供方，不是店铺招牌）。
    // 2026-09-14 店铺简称：优先简称（老周汽配），无简称回退店铺名称——resolveShopShortName 单一收口
    this.addr = '欢迎光临'
    fetchPublicConfig().then(cfg => {
      const shop = resolveShopShortName(cfg)
      if (shop) this.addr = `欢迎来到 ${shop}`
      if (cfg.icpRecordNumber) this.icpNumber = cfg.icpRecordNumber
      this.showTierBadge = cfg.showHuiliangzhengBadge !== false
    }).catch(() => { /* 拉取失败保留默认 */ })

    // 加载商品（首次请求商品池，后续不再请求后端）
    this.fetchProducts()
    this.fetchFeaturedProducts()
    this.fetchCartCount()

    // 添加滚动监听（用于返回顶部按钮和加载更多）
    window.addEventListener('scroll', this.handleScroll)
  },
  activated () {
    // keep-alive 激活时：精选推荐按本生命周期的抽样结果重设（不重新抽，避免返回首页跳变）
    if (this.featuredPool.length > 0) {
      this.featuredProducts = this.featuredPool.slice(0, 6)
    }
    // 配置类展示（欢迎语/ICP 备案/角标）从模块缓存同步：created 只跑一次，管理员在
    // SystemSetting 保存（fetchPublicConfig(true) 已强刷缓存）后切回首页即时生效，零新请求
    const cfg = getPublicConfig()
    if (cfg) {
      const shop = resolveShopShortName(cfg)
      if (shop) this.addr = `欢迎来到 ${shop}`
      this.icpNumber = cfg.icpRecordNumber || ''
      this.showTierBadge = cfg.showHuiliangzhengBadge !== false
    }
    // 购物车真相复核（spec K）：本地响应式已覆盖页内删除（Cart.vue watch → store），
    // 这里兜住"SPA 之外的变化"（他端/他标签页动过购物车）——回页即校准，无需手动刷新
    this.fetchCartCount()
  },
  beforeDestroy () {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll)
    if (this._sentinelObserver) this._sentinelObserver.disconnect()
    // 移除购物车按钮拖拽监听
    document.removeEventListener('mousemove', this.onDragCart)
    document.removeEventListener('mouseup', this.endDragCart)
    document.removeEventListener('touchmove', this.onDragCart)
    document.removeEventListener('touchend', this.endDragCart)
  },
  mounted () {
    if (document.body.clientWidth < 290) {
      this.greetScroll = true
    }
    // 初始化购物车按钮位置（使用 right/bottom 定位，与 CartFloatEntry 对齐）
    const cartBtn = this.$refs.cartFloatBtn
    if (cartBtn) {
      cartBtn.style.right = '20px'
      cartBtn.style.bottom = 'calc(160px + env(safe-area-inset-bottom))'
      cartBtn.style.left = 'auto'
      cartBtn.style.top = 'auto'
    }
    // 提前续页：sentinel 进入"距底部约 1.2 视口"预载区即追加下一批（本地池循环，不发请求）。
    // rootMargin bottom 120% = 视口下沿再扩 1.2×vh，sentinel 尚未真正入屏就触发，用户感知不到页面底部。
    // keep-alive 缓存态 DOM 不可见 → IO 不相交不回调；重新激活挂载后位置变化自然触发，无需 activated 钩子。
    this._sentinelObserver = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) this.ensurePrefill()
    }, { root: null, rootMargin: '0px 0px 120% 0px', threshold: 0 })
    this.$nextTick(() => {
      const el = this.$refs.infiniteSentinel
      if (el) this._sentinelObserver.observe(el)
    })
  },
  methods: {
    // 获取商品缩略图（marketing_image 优先；商品主图统一 utils/image 归一，不再页面自 parse）
    getProductThumb (product) {
      // 1. 营销图优先（首页/搜索/推荐位）
      if (product.marketing_image) {
        return this.$img(product.marketing_image) || this.defaultImage
      }
      // 2. 主图（正式排序 [0]；images 数组优先，空 fallback [image] 存量单图形态）
      const url = resolveProductImageUrl(product)
      return (url && this.$img(url)) || this.defaultImage
    },
    // 别名方法
    getProductImage (product) {
      return this.getProductThumb(product)
    },
    getGreetTime (hour) {
      if (hour < 6) return '夜深了'
      if (hour < 9) return '早上好'
      if (hour < 12) return '上午好'
      if (hour < 14) return '中午好'
      if (hour < 18) return '下午好'
      return '晚上好'
    },
    handleImageError (event) {
      event.target.src = this.defaultImage
    },
    formatUnit (product) {
      // 商品卡片只保留最小单位（基础单位名）；包装换算在详情页单位选择器展示
      if (Array.isArray(product.units) && product.units.length) {
        const base = product.units.find(u => u.is_base)
        if (base) return base.unit_name
      }
      return product.unit || '个'
    },
    async fetchProducts () {
      try {
        this.loading = true
        // 瀑布流候选池：推荐(feed) 一次取回大池，前端 weightedSample 按 session seed 抽样。
        // feed 已按权重降序（推荐在前=高权重），weightedSample 保留趋势：top 高曝光 + 长尾探索。
        const token = localStorage.getItem('token')
        const headers = token ? { Authorization: `Bearer ${token}` } : {}
        const res = await this.axios.get('/recommendations/feed', {
          params: { size: this.limit },
          headers,
          timeout: 5000
        })
        if (res.data.code === 200) {
          this.productPool = res.data.data || []
          if (this.productPool.length) {
            if (!this._feedSeed) this._feedSeed = (Math.random() * 0xffffffff) >>> 0
            // §24 去重末环（更多好货补位）：首批跳过 个性化/促销/新品/精选 已展示 id。
            // 等依赖落地（上限 5.5s，聚合区/精选失败不拖垮瀑布流首屏）；被掏空的池放开回全池。
            // 续页轮次（loadmore 换 seed 重排）仍用全池——长尾浏览允许复现，去重只管首屏陈列
            await this._waitDeps()
            const excl = new Set([...(this._aggIds || []), ...(this._featIds || [])])
            const deduped = excl.size ? this.productPool.filter(p => !excl.has(p.id)) : this.productPool
            const firstPass = deduped.length >= this.BATCH_SIZE ? deduped : this.productPool
            // stockFirst 分层：有货段 weightedSample 在前、无货段沉底（段内 top/explore 权重结构不变）
            this._shuffledPool = stockFirst(firstPass, sub => weightedSample(sub, this._feedSeed))
            this._round = 0 // 轮次：循环第二轮起同商品靠 _round 区分 key（id-_round）
            this.products = this._shuffledPool.slice(0, this.BATCH_SIZE).map(p => ({ ...p, _round: 0 }))
            this._poolIndex = this.BATCH_SIZE
          }
        }
      } catch (err) {
        console.error('获取商品失败:', err)
      } finally {
        this.loading = false
        // 首批落 DOM 后点火预载链：首屏/PC 大屏内容不足时连续补 batch，直到 sentinel 退出预载区
        this.$nextTick(() => this.ensurePrefill())
      }
    },
    async fetchFeaturedProducts () {
      try {
        const TARGET = 6 // 精选推荐固定展示 6 个（§19；不是一屏全见——33vw 卡横滑，一屏 2.5~3 张）
        const CANDIDATES = 16 // 候选池规模（后端按权重降序取 16，展示层再抽——不因只展示6就只算6）
        const token = localStorage.getItem('token')
        this._recMeta = {} // product_id → recommendation_id（impression/click 归因用）
        // 抽样 seed：每次进入首页（created）重新生成 → 重新进入换一批；
        // 同一次页面生命周期内不重生成（weightedSample 同 seed 同序）→ rerender 稳定不跳
        this._featuredSeed = (Math.random() * 0xffffffff) >>> 0

        let adminP = [] // 管理员强推（配置顺序即优先级）
        let recP = [] // 个性化候选池
        let coldP = [] // Cold Start 混合候选池（热销+新品+随机+分类探索；仅个性化不足时拉取）

        // 优先级 1：管理员精选（最前，所有用户一致；admin 配了就排最前）
        try {
          const configRes = await this.axios.get('config/featured-products')
          let productIds = []
          if (configRes.data.code === 200 && configRes.data.data) {
            productIds = configRes.data.data
          }
          if (productIds.length > 0) {
            const res = await this.axios({
              url: apiConfig.apiList.getProducts,
              method: 'get',
              params: { ids: productIds.slice(0, 50).join(',') }
            })
            if (res.data.code === 200) {
              const productsMap = {}
              res.data.data.forEach(p => { productsMap[p.id] = p })
              adminP = productIds.map(id => productsMap[id]).filter(p => p)
            }
          }
        } catch (_) {}

        // 优先级 2：个性化推荐候选池（需 token；记录 recommendation_id 供归因）。
        // admin 纯池语义不变（配了就排最前）；recP 现在也供 §19 补位用（admin 池不足 6 时补满）
        if (token) {
          try {
            const recRes = await this.axios.get('/recommendations', {
              params: { limit: CANDIDATES },
              headers: { Authorization: `Bearer ${token}` },
              timeout: 3000
            })
            if (recRes.data.code === 200 && recRes.data.data) {
              const recData = recRes.data.data
              recData.forEach(r => { if (r.product_id) this._recMeta[r.product_id] = r.recommendation_id })
              recP = recData.map(item => item.product).filter(p => p)
            }
          } catch (_) { /* 推荐失败/超时 → 静默 fallback */ }
        }

        // 优先级 3：Cold Start 混合候选池（热销+新品+随机探索+分类探索，后端多来源合成）。
        // 员工/匿名/新用户无画像 → recP 空 → 走这里；admin+rec 已够补位时不触发、路径不变。
        if (adminP.length + recP.length < TARGET) {
          try {
            const res = await this.axios.get('/recommendations/cold-start', {
              params: { size: 16 }, timeout: 3000
            })
            if (res.data.code === 200) coldP = res.data.data || []
          } catch (_) {}
          if (coldP.length < TARGET) {
            // cold-start 失败 → 退回旧热销兜底（确保首页不白屏）
            try {
              const res = await this.axios.get(apiConfig.apiList.getProducts, {
                params: { sortType: 'sales', limit: CANDIDATES }
              })
              if (res.data.code === 200) coldP = res.data.data || []
            } catch (_) {}
          }
        }

        // 短期防重复：上一批精选 id（sessionStorage，会话级——仅回退链使用；精选池轮换均匀抽，不排除上批）
        let lastIds = []
        try { lastIds = JSON.parse(sessionStorage.getItem('featured_last_ids') || '[]') } catch (_) {}

        // §24 去重第 4 环（精选）：跳过聚合区（个性化/促销/新品）已展示 id——只等 _aggIds
        // （_featIds 是本函数 finally 才设的，等它=自锁）。放在候选拉取之后：
        // 请求并行跑，只有装配前才真正等，不给精选链加串行延迟
        await this._waitDeps(['_aggIds'])
        const aggIds = this._aggIds || []

        let featured
        if (adminP.length > 0) {
          // 精选池轮换（Featured Rotation）：管理员配置 = 池成员资格，展示集合与顺序由 seed 决定。
          // 有效池（?ids= 批量详情已滤下架/删除）先过 §24 去重再 seededShuffle → slice(0,6)：
          // 均匀无重复；池不足 TARGET 放开回全池（§24 允许 fallback）。刻意不用 weightedSample——
          // 精选位机会均等（§10 不引入权重），也不混入推荐/热销商品（§4 只展示池内商品）。
          // 同 seed 同序（同次进入稳定），seed 每次进入重生成（重进换批）。
          const aggSet = new Set(aggIds)
          const dedupedAdmin = aggSet.size ? adminP.filter(p => !aggSet.has(p.id)) : adminP
          const adminPool = dedupedAdmin.length >= TARGET ? dedupedAdmin : adminP
          featured = sampleBySeed(adminPool, this._featuredSeed, TARGET)
        } else {
          // N=0：保持既有回退链——个性化候选 weightedSample 加权抽 + exclude 短期防重复 + §24 聚合区已示
          featured = buildFeatured({ rec: recP, hot: coldP, exclude: [...lastIds, ...aggIds], seed: this._featuredSeed, target: TARGET })
        }
        // §19 补满 6：admin 池（或回退链）不足 TARGET 时从另一链补位——admin 序保持在前，
        // 补位商品同样过 §24 聚合区去重 + 短期防重复（dev 实测 admin 只配 4 个 → 补 2）
        if (featured.length < TARGET) {
          const used = [...featured.map(p => p.id), ...aggIds, ...lastIds]
          const topUp = buildFeatured({ rec: recP, hot: coldP, exclude: used, seed: (this._featuredSeed + 1) >>> 0, target: TARGET - featured.length })
          featured = featured.concat(topUp)
        }
        if (featured.length > 0) {
          this.featuredPool = featured
          this.featuredProducts = featured.slice(0, TARGET)
          try { sessionStorage.setItem('featured_last_ids', JSON.stringify(featured.map(p => p.id))) } catch (_) {}
          // 仅对「实际展示且来自推荐」的商品记 impression（admin 优先后推荐未必进前4）
          this.logRecImpression(this.featuredProducts)
        }
      } catch (err) {
        // 优先级 4：全失败 → 热销候选池加权抽 6（确保首页不白屏，也不固定前6）
        console.error('获取推荐商品失败，fallback 热销:', err)
        try {
          const res = await this.axios.get(apiConfig.apiList.getProducts, { params: { sortType: 'sales', limit: 12 } })
          if (res.data.code === 200) {
            const featured = buildFeatured({ hot: res.data.data || [], seed: (Math.random() * 0xffffffff) >>> 0 })
            this.featuredPool = featured
            this.featuredProducts = featured.slice(0, 6)
          }
        } catch (_) { /* 彻底失败，首页精选区空白，不白屏 */ }
      } finally {
        // §24 依赖信号：精选已示 id 落地（瀑布流首批去重在等；失败/空 也释放，不挂起）
        this._depSet('_featIds', (this.featuredProducts || []).map(p => p.id))
      }
    },
    // 异步记录推荐展示（impression）：只记实际展示且来自推荐的商品，不阻塞首页
    logRecImpression (displayed) {
      const token = localStorage.getItem('token')
      if (!token) return
      this._recProductIds = {} // product_id → recommendation_id（点击归因用）
      displayed.forEach(p => {
        const rid = this._recMeta && this._recMeta[p.id]
        if (!rid) return
        this._recProductIds[p.id] = rid
        this.axios.post('/recommendations/events', {
          product_id: p.id,
          recommendation_id: rid,
          event_type: 'impression'
        }, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {})
      })
    },
    // ===== §24 跨模块去重的依赖信号（实例属性，非响应式；_ 前缀惯例同 _feedSeed）=====
    // 聚合区（个性化/促销/新品）已示 id 上报；精选落地信号在 fetchFeaturedProducts finally。
    // 多个等待者共享同一 Promise（memoize），_waitDeps 带超时——模块失败不拖垮等待方首屏
    onAggShown (ids) {
      this._depSet('_aggIds', ids || [])
    },
    _depReady (key) {
      if (this[key]) return Promise.resolve()
      if (!this[key + 'Promise']) {
        this[key + 'Promise'] = new Promise(r => { this[key + 'Resolver'] = r })
      }
      return this[key + 'Promise']
    },
    _depSet (key, val) {
      this[key] = val
      if (this[key + 'Resolver']) { this[key + 'Resolver'](); this[key + 'Resolver'] = null }
    },
    async _waitDeps (keys, ms = 5500) {
      // keys 显式声明要等的信号——fetchFeaturedProducts 只等 _aggIds（_featIds 是它自己 finally
      // 才设的，等它=自锁到超时）；fetchProducts 等 agg+feat 两样
      const ps = []
      for (const k of (keys || ['_aggIds', '_featIds'])) {
        if (!this[k]) ps.push(this._depReady(k))
      }
      if (!ps.length) return
      await Promise.race([Promise.all(ps), new Promise(r => setTimeout(r, ms))])
    },
    // 精选推荐点击：记录 click + 跳转详情
    onFeaturedClick (product) {
      const token = localStorage.getItem('token')
      if (token && this._recProductIds && this._recProductIds[product.id]) {
        this.axios.post('/recommendations/events', {
          product_id: product.id,
          recommendation_id: this._recProductIds[product.id],
          event_type: 'click'
        }, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {})
      }
      this.toDetails(product)
    },
    toDetails (product) {
      this.$router.push({
        path: '/details',
        query: { id: product.id }
      })
    },
    // 管理员编辑商品
    editProduct (product) {
      this.$router.push(`/product/${product.id}/edit`)
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // 返回顶部按钮显示/隐藏
      this.isDisplay = scrollTop > 320
      // 货篮钮滚动状态（共享状态机：向下滚 PEEK 半透明+收边，向上滚/停 400ms 复原）
      this.updateFloatPeek(scrollTop)
      // 瀑布流续页：IO 为主触发（见 mounted），scroll 事件同口径兜底（快速 fling 下更实时）
      this.ensurePrefill()
    },
    async fetchCartCount () {
      // 单一真值：拉服务端真相进 store（cartCount/showCartFloat 全走 computed，不再落本地副本）
      await this.$store.dispatch('refreshCartCount')
    },
    loadmore () {
      // 客户端循环模式：不请求后端，从 weightedSample 序列分批追加
      if (this.loadingMore || this.loading) return
      if (this.productPool.length === 0) return

      this.loadingMore = true
      setTimeout(() => {
        // 当前位置已到池末尾 → 换 seed 重排（保留权重趋势，顺序变，非固定重复）
        if (this._poolIndex >= this._shuffledPool.length) {
          this._feedSeed = (this._feedSeed + 2654435761) >>> 0 // 黄金比例步进，解耦相邻 seed
          this._shuffledPool = stockFirst(this.productPool, sub => weightedSample(sub, this._feedSeed))
          this._poolIndex = 0
          this._round = (this._round || 0) + 1 // 新一轮：同商品第二轮起 key 靠 _round 区分
        }
        const batch = this._shuffledPool.slice(this._poolIndex, this._poolIndex + this.BATCH_SIZE)
          .map(p => ({ ...p, _round: this._round || 0 }))
        this.products = [...this.products, ...batch]
        this._poolIndex += batch.length
        this.loadingMore = false
        // 批量落 DOM 后复测预载：不足（首屏/PC 大屏/快速滑动）则继续补，sentinel 推出预载区自然停
        this.$nextTick(() => this.ensurePrefill())
      }, 300)
    },
    // 预载判定：sentinel 顶边 < 2.2×vh（视口高 + 1.2×vh 提前量，与 rootMargin 120% 同一数值口径）。
    // loadingMore 即现有互斥锁——一次触发一批；池空由 loadmore 头部短路断链。
    ensurePrefill () {
      if (this.loadingMore || this.loading) return
      const el = this.$refs.infiniteSentinel
      if (!el) return
      const rect = el.getBoundingClientRect()
      const vh = window.innerHeight || document.documentElement.clientHeight
      if (rect.top < vh * 2.2) this.loadmore()
    },
    goBackTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.isDisplay = false
    },
    // 购物车按钮拖拽相关
    onCartClick () {
      this.resetFloatPeek() // 点击即复原（共享状态机约定）
      if (!this.hasMovedCart) {
        this.$router.push('/cart')
      }
    },
    startDragCart (e) {
      // 仅 mouse preventDefault（touchstart 上 preventDefault 会吞合成 click；助手 FAB 同款）
      if (e.type === 'mousedown' && e.preventDefault) e.preventDefault()
      this.isDraggingCart = true
      this.hasMovedCart = false
      const touch = e.touches ? e.touches[0] : e
      this.dragStartXCart = touch.clientX
      this.dragStartYCart = touch.clientY
      const btn = this.$refs.cartFloatBtn
      const rect = btn.getBoundingClientRect()
      this.btnXCart = rect.left
      this.btnYCart = rect.top
      document.addEventListener('mousemove', this.onDragCart)
      document.addEventListener('mouseup', this.endDragCart)
      document.addEventListener('touchmove', this.onDragCart)
      document.addEventListener('touchend', this.endDragCart)
    },
    onDragCart (e) {
      if (!this.isDraggingCart) return
      e.preventDefault()
      const touch = e.touches ? e.touches[0] : e
      const dx = touch.clientX - this.dragStartXCart
      const dy = touch.clientY - this.dragStartYCart
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) this.hasMovedCart = true
      const btn = this.$refs.cartFloatBtn
      btn.style.left = (this.btnXCart + dx) + 'px'
      btn.style.top = (this.btnYCart + dy) + 'px'
      btn.style.right = 'auto'
      btn.style.bottom = 'auto'
    },
    endDragCart () {
      if (!this.isDraggingCart) return
      this.isDraggingCart = false
      document.removeEventListener('mousemove', this.onDragCart)
      document.removeEventListener('mouseup', this.endDragCart)
      document.removeEventListener('touchmove', this.onDragCart)
      document.removeEventListener('touchend', this.endDragCart)
      const btn = this.$refs.cartFloatBtn
      const rect = btn.getBoundingClientRect()
      const winW = window.innerWidth
      const winH = window.innerHeight
      const margin = 20
      const btnW = 50
      const btnH = 50
      const distLeft = rect.left
      const distRight = winW - rect.right
      btn.style.transition = 'all 0.3s ease'
      if (distLeft < winW / 2) {
        btn.style.left = margin + 'px'
      } else {
        btn.style.left = (winW - margin - btnW) + 'px'
      }
      const top = Math.max(margin, Math.min(winH - margin - btnH, rect.top))
      btn.style.top = top + 'px'
      setTimeout(() => { btn.style.transition = '' }, 300)
    }
  }
}
